export default {
    setConnections(state, connections)
    {
        state.connections = connections;
    }
}
